// components/DynamicModal.tsx
import React from "react";
import { Modal } from "antd";

interface DynamicModalProps {
  title: string;
  open: boolean;
  onOk: () => void;
  onCancel: () => void;
  okText?: string;
  cancelText?: string;
  width?: number | string;
  children: React.ReactNode;
  centered?: boolean;
  destroyOnClose?: boolean;
}

const DynamicModal: React.FC<DynamicModalProps> = ({
  title,
  open,
  onOk,
  onCancel,
  okText = "OK",
  cancelText = "Cancel",
  width = 600,
  children,
  centered = true,
  destroyOnClose = true,
}) => {
  return (
    <Modal
      title={title}
      open={open}
      onOk={onOk}
      onCancel={onCancel}
      okText={okText}
      cancelText={cancelText}
      width={width}
      centered={centered}
      destroyOnClose={destroyOnClose}
    >
      {children}
    </Modal>
  );
};

export default DynamicModal;
